/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseVisitDto } from '../../models/response-visit-dto';
import { UpdateVisitDto } from '../../models/update-visit-dto';

export interface VisitsControllerUpdate$Params {

/**
 * The tenant of the visit
 */
  tenant: string;

/**
 * The unique identifier of the visit
 */
  id: string;
      body: UpdateVisitDto
}

export function visitsControllerUpdate(http: HttpClient, rootUrl: string, params: VisitsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVisitDto>> {
  const rb = new RequestBuilder(rootUrl, visitsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseVisitDto>;
    })
  );
}

visitsControllerUpdate.PATH = '/thalea-pathways/visits/{tenant}/{id}';
